export enum EnvironmentType {
  LOCAL = 'local',
  DEVELOP = 'develop',
  STAGING = 'staging',
  PRODUCTION = 'prod',
  DEUX = 'deux'
}
